export { default } from './Institutional';
export type { InstitutionalLayoutProps } from './Institutional';
